export const newVersionAvailableText = 'A new version of the application is available.'
